import { createContext, useContext, type MutableRefObject } from 'react';

import type { NovaNavigation, NovaNavigationActions } from './types';
import type { SettingsPanelCloseGuard } from '../components/settings-panel-context';

export interface NovaNavigationContextValue extends NovaNavigation {
  actions: NovaNavigationActions;
  backHandlerRef: MutableRefObject<SettingsPanelCloseGuard | null>;
}
export const NovaNavigationContext = createContext<NovaNavigationContextValue | null>(null);
export function useNovaNavigationSafe() {
  return useContext(NovaNavigationContext);
}
export function useNovaNavigation() {
  const context = useNovaNavigationSafe();
  if (!context) throw new Error('useNovaNavigation must be used within NovaProvider');
  return context;
}
